import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import { customToolTipVariant } from "./ToolTipStyles";

// The following component displays the content of the tooltip
function CustomLabelToolTip({ subtopicText, subtopicNames, variant }) {
  let SubtopicListStyle =
    variant === "TaskCard" ||
    variant === "UpdatesMobile" ||
    variant === "UpdatesDesktop"
      ? customToolTipVariant?.subtopicNamesText
      : variant === "Login"
      ? customToolTipVariant?.loginTitle
      : customToolTipVariant?.normalTexts;
  return (
    <Flex sx={customToolTipVariant?.labelToolTipBox}>
      <Text sx={customToolTipVariant?.subtopicTitle}>{subtopicText}</Text>
      <Text sx={SubtopicListStyle}>{subtopicNames}</Text>
    </Flex>
  );
}

export default CustomLabelToolTip;
